<template>
  <div>
    <v-row dense class="pb-2 align-center">
      <v-col
        cols="12"
        md="6"
        offset-md="6"
        offset-lg="8"
        lg="4"
        class="d-flex text-right align-center"
      >
        <v-text-field
          v-model="searchQuery"
          append-icon="mdi-magnify"
          class="mr-md-2"
          solo
          hide-details
          dense
          clearable
          placeholder="Search Project"
        ></v-text-field>
        <v-btn icon small class="ml-2" @click="refresh">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-card v-if="!projects || projects.length < 1">
      <v-card-text>
        <div class="text-center">
          No Project found...
        </div>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      hide-default-header
      hide-default-footer
      :items="projects"
      :search="searchQuery"
      no-data-text="No project found"
    >
      <template v-slot:body="item">
        <div v-for="project in item.items" :key="project.uuid">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 0" class="pa-2 cursor-pointer">
              <div
                class="project d-flex align-center justify-space-between flex-wrap flex-md-nowrap"
              >
                <div
                  class="d-flex align-center pr-2"
                  @click="openSchedules(project)"
                >
                  <div>
                    <v-img
                      width="80"
                      height="60"
                      src="https://picsum.photos/id/11/100/60"
                    ></v-img>
                  </div>
                  <div class="ml-1">
                    <h6 class="primary--text pb-0 mb-0">
                      <strong>{{ project.name }}</strong>
                    </h6>
                    <div>
                      <strong>Architect: </strong>
                      <span
                        >{{
                          project.selected_architect &&
                          project.selected_architect.company
                            ? project.selected_architect.company
                            : "N/A"
                        }},
                      </span>
                      <strong
                        >{{
                          project.selected_architect &&
                          project.selected_architect.name
                            ? project.selected_architect.name
                            : "N/A"
                        }}
                      </strong>
                    </div>
                    <div>
                      <strong>Project Address: </strong>
                      <span
                        >{{
                          project.address.address_line_1 &&
                            project.address.address_line_1
                        }}
                        {{
                          project.address.address_line_2 &&
                            project.address.address_line_2
                        }}, {{ project.address.city && project.address.city }}
                        {{ project.address.state && project.address.state }}
                        {{ project.address.zip && project.address.zip }}</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-grow-1 align-center justify-md-end justify-space-between mt-2 mt-md-0"
                >
                  <div class="d-flex">
                    <v-btn
                      v-if="isArchitect()"
                      depressed
                      color="primary"
                      class="white--text"
                      @click="invite(project)"
                      ><v-icon color="white" class="mr-1"
                        >mdi-share-variant</v-icon
                      >
                      Invite</v-btn
                    >
                    <div class="ml-2 mr-3 mr-lg-5">
                      <span
                        >Last update:
                        {{
                          new Date(project.last_updated).toLocaleDateString()
                        }}</span
                      >
                      <br />
                      <span>Status: </span>
                      <span class="success--text" v-if="isArchitect()"
                        >Active</span
                      >
                      <span class="success--text" v-if="isDealer()">New</span>
                    </div>
                  </div>

                  <v-menu v-if="isArchitect()" offset-y left>
                    <template v-slot:activator="{ on }">
                      <transition name="slide-fade" mode="out-in">
                        <v-btn icon v-on="on">
                          <v-icon size="32" color="primary">
                            mdi-dots-horizontal
                          </v-icon>
                        </v-btn>
                      </transition>
                    </template>
                    <v-list dense>
                      <v-list-item @click="updateProject(project)">
                        <v-icon size="18" class="mr-1">mdi-cog</v-icon>
                        <v-list-item-title>Edit</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="projectMembers(project)">
                        <v-icon size="18" class="mr-1">mdi-account</v-icon>
                        <v-list-item-title>Manage Members</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteProject(project)">
                        <v-icon size="18" class="mr-1">mdi-delete</v-icon>
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-menu v-if="isDealer()" offset-y left>
                    <template v-slot:activator="{ on }">
                      <transition name="slide-fade" mode="out-in">
                        <v-btn icon v-on="on">
                          <v-icon size="32" color="primary">
                            mdi-dots-horizontal
                          </v-icon>
                        </v-btn>
                      </transition>
                    </template>
                    <v-list dense>
                      <v-list-item @click="declineProject(project)">
                        <v-icon size="18" class="mr-1"
                          >mdi-minus-circle-outline</v-icon
                        >
                        <v-list-item-title>Decline</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteDealerProject(project)">
                        <v-icon size="18" class="mr-1">mdi-delete</v-icon>
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </v-card>
          </v-hover>
          <v-divider></v-divider>
        </div>
        <div
          v-if="projects && projects.length && pagination"
          class="text-center pb-3"
        >
          <v-pagination
            v-model="pagination.page"
            :length="pagination.totalPages"
            @input="paginateProjects"
          ></v-pagination>
        </div>
      </template>
    </v-data-table>

    <AddEditProject
      v-if="editModal"
      :dialog="editModal"
      :projectInfo="selectedProject"
      :edit="true"
      @refresh="refresh"
      @close="editModal = false"
    />

    <InviteUsers
      v-if="inviteModal && selectedProject"
      :project="selectedProject"
      :dialog="inviteModal"
      @close="inviteModal = false"
    />

    <ProjectSchedules
      v-if="scheduleModal && selectedProject"
      :project="selectedProject"
      :dialog="scheduleModal"
      @close="scheduleModal = false"
    />

    <ManageMembers
      v-if="membersModal && selectedProject"
      :dialog="membersModal"
      :project="selectedProject"
      @close="membersModal = false"
    />

    <DeleteProject
      v-if="deleteModal && selectedProject"
      :dialog="deleteModal"
      :project="selectedProject"
      @refresh="refresh"
      @close="deleteModal = false"
    />
  </div>
</template>

<script>
import AddEditProject from "@/components/project/AddEditProject";
import InviteUsers from "@/components/project/InviteUsers";
import ProjectSchedules from "@/components/project/ProjectSchedules";
import ManageMembers from "@/components/project/ManageMembers";
import DeleteProject from "@/components/project/DeleteProject";
export default {
  components: {
    AddEditProject,
    InviteUsers,
    ProjectSchedules,
    ManageMembers,
    DeleteProject
  },
  props: {
    projectList: { type: Array, default: null },
    paginationObj: { type: Object, default: null },
    isLoading: { type: Boolean, default: false }
  },
  data() {
    return {
      projects: [],
      selectedProject: null,
      pagination: null,
      scheduleModal: false,
      editModal: false,
      membersModal: false,
      deleteModal: false,
      deleteDealerModal: false,
      inviteModal: false,
      declineModal: false,
      searchQuery: null,
      headers: [
        {
          text: "project",
          value: "name"
        },
        {
          text: "actions",
          value: "action"
        }
      ]
    };
  },
  watch: {
    projectList(val) {
      if (val && val.length) {
        this.projects = JSON.parse(JSON.stringify(val));
      }
    },
    paginationObj(val) {
      if (val) {
        this.pagination = JSON.parse(JSON.stringify(val));
      }
    }
  },
  created() {
    if (this.projectList && this.projectList.length) {
      this.projects = JSON.parse(JSON.stringify(this.projectList));
    }
    if (this.paginationObj) {
      this.pagination = JSON.parse(JSON.stringify(this.paginationObj));
    }
  },
  methods: {
    deleteProject(item) {
      this.selectedProject = { ...item };
      this.deleteModal = true;
    },
    deleteDealerProject(item) {
      this.selectedProject = { ...item };
      this.deleteDealerModal = true;
    },
    updateProject(item) {
      this.selectedProject = { ...item };
      this.editModal = true;
    },
    declineProject(item) {
      this.selectedProject = { ...item };
      this.declineModal = true;
    },
    projectMembers(project) {
      this.selectedProject = { ...project };
      this.membersModal = true;
    },
    openSchedules(project) {
      this.selectedProject = { ...project };
      this.scheduleModal = true;
    },
    invite(project) {
      this.selectedProject = { ...project };
      this.inviteModal = true;
    },
    refresh() {
      this.deleteModal = false;
      this.editModal = false;
      this.inviteModal = false;
      this.membersModal = false;
      this.scheduleModal = false;
      this.$emit("refresh", true);
    },
    paginateProjects(value) {
      this.$emit("paginate", value);
    }
  }
};
</script>
